/**
 * @generated SignedSource<<129113540a49f36f9c37a6a21f69a9aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardTable_PilotMachinesQuery$variables = {};
export type DashboardTable_PilotMachinesQuery$data = {
  readonly pilotMachines: ReadonlyArray<{
    readonly createdAt: any | null;
    readonly id: string;
    readonly location: {
      readonly deploymentManager: {
        readonly firstName: string;
        readonly id: string;
      } | null;
      readonly id: string;
      readonly name: string;
      readonly region: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly servicePlan: {
        readonly id: string;
        readonly indicater: string | null;
      } | null;
    } | null;
    readonly macAddress: string | null;
    readonly machineStatus: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly name: string | null;
    readonly serialNumber: string;
    readonly trialEndDate: string | null;
    readonly uuid: string | null;
  }>;
};
export type DashboardTable_PilotMachinesQuery = {
  response: DashboardTable_PilotMachinesQuery$data;
  variables: DashboardTable_PilotMachinesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MachineObjectType",
    "kind": "LinkedField",
    "name": "pilotMachines",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serialNumber",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "macAddress",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "trialEndDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationObjectType",
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserObjectType",
            "kind": "LinkedField",
            "name": "deploymentManager",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ServicePlanObjectType",
            "kind": "LinkedField",
            "name": "servicePlan",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "indicater",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RegionObjectType",
            "kind": "LinkedField",
            "name": "region",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MachineStatusObjectType",
        "kind": "LinkedField",
        "name": "machineStatus",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardTable_PilotMachinesQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DashboardTable_PilotMachinesQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "7ccb33df513e0170266340c4d6fe2698",
    "id": null,
    "metadata": {},
    "name": "DashboardTable_PilotMachinesQuery",
    "operationKind": "query",
    "text": "query DashboardTable_PilotMachinesQuery {\n  pilotMachines {\n    id\n    uuid\n    serialNumber\n    name\n    macAddress\n    createdAt\n    trialEndDate\n    location {\n      id\n      name\n      deploymentManager {\n        id\n        firstName\n      }\n      servicePlan {\n        id\n        indicater\n      }\n      region {\n        id\n        name\n      }\n    }\n    machineStatus {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ece07bba32e6350caa1f8990a4994935";

export default node;
